import React, { useEffect, useState, useCallback } from 'react'
import {
  requestManufacturers,
  requestManufacturerUpdate,
  requestManufacturerCreate,
} from 'requests/manufacturers'
import { PRODUCTS_SUBMENU } from 'constants/menu/submenus'
import { ListPage } from 'templates/ListPage'
import { SideMenu } from 'components/SideMenu'
import { newManufacturer } from 'constants/objects/manufacturer'
import { Manufacturer } from './components/Manufacturer'
import { Form } from './components/Form'

export default function ManufacturersList() {
  const [manufacturers, setManufacturers] = useState([])
  const [responseError, setResponseError] = useState({})
  const [pagination, setPagination] = useState()
  const [loading, setLoading] = useState(true)
  const [showForm, setShowForm] = useState(false)
  const [currentManufacturer, setCurrentManufacturer] = useState()
  const [saving, setSaving] = useState(false)

  const getManufacturers = useCallback(async () => {
    setCurrentManufacturer(null)
    const response = await requestManufacturers()

    setLoading(false)
    if (response.error) return setResponseError(response)

    setPagination(response.meta?.pagination)
    return setManufacturers(response.data)
  }, [])

  useEffect(() => {
    getManufacturers()
  }, [getManufacturers])

  const onManufacturerUpdate = async (params) => {
    setSaving(true)
    const resp = await requestManufacturerUpdate(currentManufacturer.id, params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    return getManufacturers()
  }

  const onManufacturerCreate = async (params) => {
    setSaving(true)
    const resp = await requestManufacturerCreate(params)

    setSaving(false)
    if (resp.error) return setResponseError(resp)

    setShowForm(false)
    return getManufacturers()
  }

  const onSave = (params) => {
    if (!currentManufacturer?.id) {
      return onManufacturerCreate(params)
    }

    return onManufacturerUpdate(params)
  }

  const onSelectManufacturer = (manufacturer) => {
    setCurrentManufacturer(manufacturer)
    setShowForm(true)
  }

  const onToggleForm = (show = false) => {
    if (!show) setCurrentManufacturer(null)
    setResponseError(null)
    setShowForm(show)
  }

  const renderForm = () => (
    <Form
      manufacturer={currentManufacturer || newManufacturer}
      onCancel={() => onToggleForm(false)}
      onSave={onSave}
      saving={saving}
      responseError={responseError}
    />
  )

  const renderMenu = () => (
    <SideMenu submenu={PRODUCTS_SUBMENU} />
  )

  const renderManufacturer = (manufacturer) => (
    <Manufacturer
      manufacturer={manufacturer}
      onClick={onSelectManufacturer}
      key={`manufacturer-${manufacturer.id}`}
    />
  )

  return (
    <ListPage
      renderForm={renderForm}
      renderMenu={renderMenu}
      listTitle="Lista de fabricantes"
      onClickPagination={() => {}}
      pagination={pagination}
      loading={loading}
      showForm={showForm}
      onToggleForm={onToggleForm}
      showAddButton
    >
      { manufacturers.map(renderManufacturer) }
    </ListPage>
  )
}
